import Glide from "@glidejs/glide"

document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll(".glide.glide-general")
  for (let i = 0; i < sliders.length; i++) {
    if (sliders[i]) {
      new Slider(sliders[i])
    }
  }
})

class Slider {
  constructor(sliderContainer) {
    this.sliderContainer = sliderContainer
    this.slider = new Glide(sliderContainer, {
      type: "carousel",
      perView: 1,
      gap: 0,
      autoplay: 6000,
      hoverpause: false,
      animationDuration: 2000,
      keyboard: false,
    }).mount()

    this.handleClickEvents()
  }

  handleClickEvents() {
    this.sliderContainer.addEventListener("click", (e) => {
      if (e.target.classList.contains("hero-link")) return
      const clientX = e.clientX
      const centerPointX = this.sliderContainer.clientWidth / 2

      if (clientX < centerPointX) {
        this.slider.go("<")
      } else {
        this.slider.go(">")
      }
    })
  }
}
